import { useQuery } from "@tanstack/react-query";
import { process } from "am-tax-fe-core";

import { centralApi } from "../api.ts";
import { queryKeys } from "../queryKeys";

export type BannerType = 1 | 2 | 3;

export interface BannerResponse {
    id: number;
    title: string;
    description: string;
    note?: string | null;
    engageLinkText: string;
    engageLink: string;
    videoLinkText?: string | null;
    videoLink?: string | null;
    infoLinkText?: string | null;
    infoLink?: string | null;
    isInternal: boolean;
    bannerType: BannerType;
    startDate?: string | null;
    endDate?: string | null;
}

const getBannersPath = "/api/Admin/banners";
type UntypedGet = (path: string) => Parameters<typeof process>[0];

export const getBanners = async (): Promise<BannerResponse[]> =>
    centralApi(client => {
        const get = client.GET as unknown as UntypedGet;
        return process(get(getBannersPath)) as Promise<BannerResponse[]>;
    });

export function useBanners() {
    return useQuery({
        ...queryKeys.admin.banners,
        queryFn: getBanners,
        gcTime: 24 * 3600000, // 1 day garbage collection time, since banners don't change often
        staleTime: 24 * 3600000, // 1 day stale time, since banners don't change often
    });
}
